import type React from "react";

export function UploadDocumentIcon({ size = 16 }: { size?: number }): React.ReactNode {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      fill="none"
      viewBox="0 0 14 16"
      className="shrink-0"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M3.5 6.667V3a1 1 0 012 0v3.667a2 2 0 11-4 0V4m6.333-2.667h1.8c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874c.218.428.218.988.218 2.108v6.934c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874c-.428.218-.988.218-2.108.218H5.367c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874c-.218-.428-.218-.988-.218-2.108V11"
      />
    </svg>
  );
}
